"use client";

import React from "react";
import { BookOpen, Clock, Download, MonitorPlay, Target, Users } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function CoursesTableBody() {
  const {
    posts,
    loading
  } = usePosts();
  if (loading) {
    return <TableBody>
        {[...Array(5)].map((_, i) => <TableRow key={i} className="animate-pulse">
            <TableCell colSpan={4} className="py-8">
              <div className="h-4 bg-muted rounded w-3/4 mx-auto" />
            </TableCell>
          </TableRow>)}
      </TableBody>;
  }
  if (posts.length === 0) {
    return <TableBody>
        <TableRow>
          <TableCell colSpan={4} className="py-12 text-center text-muted-foreground">
            Nessun corso di formazione disponibile al momento.
          </TableCell>
        </TableRow>
      </TableBody>;
  }
  return <TableBody>
      {posts.map((post, i) => <Link key={post.id} to={post.link || post.permalink} data-index={i} className="contents">
          <TableRow className="group cursor-pointer">
            <TableCell className="py-4">
              <div className="flex items-center gap-4">
                <div className="size-10 bg-primary/10 rounded-lg overflow-hidden flex items-center justify-center group-hover:bg-primary transition-colors duration-300">
                  <img src={post.customFields?.featured_image || post.featuredImage || 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1585744/img/default_course.png'} alt={post.customFields?.title || post.title || 'Corso'} className="size-full object-cover" loading="lazy" />
                </div>
                <span className="font-semibold text-foreground group-hover:text-primary transition-colors">
                  {post.customFields?.title || post.title || 'Corso senza titolo'}
                </span>
              </div>
            </TableCell>
            <TableCell className="py-4 text-muted-foreground font-medium">
              <div className="flex items-center gap-2">
                <Clock className="size-4 opacity-70" />
                {post.customFields?.duration}
              </div>
            </TableCell>
            <TableCell className="py-4 text-muted-foreground font-medium">
              <div className="flex items-center gap-2">
                <Target className="size-4 opacity-70" />
                {post.customFields?.recipients}
              </div>
            </TableCell>
            <TableCell className="py-4 text-right">
              <div className="inline-flex items-center justify-end gap-2 px-3 py-1.5 rounded-md bg-secondary/10 text-secondary-foreground text-sm font-semibold">
                <div className="flex items-center gap-1.5">
                  <Users className="size-4" />
                  <MonitorPlay className="size-4 opacity-70" />
                  {post.customFields?.delivery_method}
                </div>
              </div>
            </TableCell>
          </TableRow>
        </Link>)}
    </TableBody>;
}
export default function INostriCorsiDiFormazione() {
  const wp_query_params = {
    post_type: "corso",
    per_page: 20
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="i-nostri-corsi-di-formazione" className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-12">
          <div className="max-w-3xl">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground tracking-tight mb-4">
              I Nostri Corsi di Formazione
            </h2>
            <p className="text-lg text-muted-foreground">
              Programmi formativi completi e costantemente aggiornati secondo le normative vigenti (D.Lgs 81/08). 
              Garantisci la sicurezza della tua azienda affidandoti alla competenza dei nostri docenti esperti.
            </p>
          </div>
          <Button size="lg" className="shrink-0 gap-2 shadow-md" asChild>
            <Link to="#">
              <Download className="size-5" />
              Scarica Calendario
            </Link>
          </Button>
        </div>

        <div className="bg-card border border-border rounded-xl shadow-sm overflow-hidden">
          <Table>
            <TableHeader className="bg-muted/50">
              <TableRow>
                <TableHead className="w-[45%] py-5 text-xs font-bold uppercase tracking-wider text-muted-foreground">
                  Corso di Formazione
                </TableHead>
                <TableHead className="py-5 text-xs font-bold uppercase tracking-wider text-muted-foreground">
                  Durata
                </TableHead>
                <TableHead className="py-5 text-xs font-bold uppercase tracking-wider text-muted-foreground">
                  Destinatari
                </TableHead>
                <TableHead className="py-5 text-xs font-bold uppercase tracking-wider text-muted-foreground text-right">
                  Modalità
                </TableHead>
              </TableRow>
            </TableHeader>
            <PostsProvider wp_query={{
            post_type: "corso",
            per_page: 20
          }}>
              <CoursesTableBody />
            </PostsProvider>
          </Table>
        </div>
      </div>
    </section>;
}